// extracted by mini-css-extract-plugin
export default {"wrapper":"Button_wrapper__2xDaB"};